import * as React from "react";
import { Form, FormElement } from '@progress/kendo-react-form';
import { Switch } from '@progress/kendo-react-inputs';
import { AppUser } from "../../models/appUser";

interface EmailNotificationSettingsProps {
    isLoading: boolean,
    appUser?: AppUser,
    onChange_AppUser: Function,
    children?: React.ReactNode
}

export const EmailNotificationSettings = (props: EmailNotificationSettingsProps) => {
    return <div>
        <Form
            render={() => (
                <FormElement
                    style={{
                        width: '100%',
                        height: '348px',
                        background: '#fafafa',
                        padding: '0px 16px 0px 16px',
                        border: '1px solid rgba(0, 0, 0, 0.08)',
                    }}
                >
                    <br />
                    <br />
                    <br />
                    <div className="mb-3 switch-options">
                        <div className="switch-parent">
                            <div>
                                <p>New PVS Kit Submission</p>
                                <p className="gray-text">Get an email when a new PVS kit is submitted to a lab you are linked to.</p>
                            </div>
                            <Switch defaultChecked={props.appUser?.ReceiveKitSubmissionEmails} onChange={(event) => props.onChange_AppUser(event, 'ReceiveKitSubmissionEmails')} />
                        </div>

                    </div>
                    <div className="mb-3">
                        <div className="switch-parent switch-options">
                            <div>
                                <p>PVS Kit Submission Completed</p>
                                <p className="gray-text">Get an email when a new PVS kit is completed for a lab you are linked to</p>

                            </div>
                            <Switch defaultChecked={props.appUser?.ReceiveKitCompletedEmails} onChange={(event) => props.onChange_AppUser(event, 'ReceiveKitCompletedEmails')} />
                        </div>
                    </div>
                </FormElement>
            )}
        />
        <br />
        <br />
        <br />
        <div className="right" style={{
            marginTop: '20px'
        }}>
        </div>
    </div>
}